import React from 'react';
import './Testimonials.css';

function Testimonials() {
    return (
        <section id="reviews" className="testimonials" aria-labelledby="reviews-title">
            <div className="container">
                <div className="testimonials-header">
                    <div>
                        <p className="section-kicker">Отзыв о бренде</p>
                        <h2 id="reviews-title">Говорят<br />о нас.</h2>
                    </div>
                    <span aria-hidden="true">“</span>
                </div>
                <blockquote className="testimonial">
                    <p className="testimonial-text">
                        «Это Россия» — это красиво! А еще качественно и со всей душой.
                    </p>
                    <footer className="testimonial-author">
                        <img
                            src="https://static.tildacdn.com/tild6639-6564-4662-a537-666430653737/2025-10-23_135052.jpg"
                            alt="Дарья Колесникова — отзыв о бренде ЭТО РОССИЯ"
                            className="testimonial-avatar"
                            width={80}
                            height={80}
                            loading="lazy"
                        />
                        <div>
                            <cite className="testimonial-name">Дарья Колесникова</cite>
                            <span>Отзыв о бренде</span>
                        </div>
                    </footer>
                </blockquote>
            </div>
        </section>
    );
}

export default Testimonials;
